import _ from 'lodash'

export const checkUserIsAuthor = (direct, user) => {
  const userId = _.get(user, 'id', '-1')
  const authorId = _.get(direct, 'author.id', '-2')
  return userId === authorId
}
